export const tableTooLarge = (rows, columns) => {
  return rows * columns > 1500;
};